<div class="app-search hidden-sm-down ml-3">
    <form [formGroup]="frmSearch">
        <input type="text" formControlName="searchText" placeholder="Type to search..." class="form-control"
            autocomplete="off" (click)="show=true;">
    </form>
</div>
<!-- Search pop over bottom Results -->
<div class="col-12 align-items-center popover-static " *ngIf="frmSearch.get('searchText').value!='' && show==true">
    <div class="col-xl-12 col-lg-12 col-xs-12 mb-12">
        <div class="popover popover-left ">
            <div align="left"><i class="fa fa-close" (click)="show=false;"></i></div>
            <h5 class="popover-title"> Search Results for "{{frmSearch.get('searchText').value}}"</h5>
            <div class="popover-content">
                <div class="col-12 panel-body" *ngIf="result!=0" style="overflow-y: auto; max-height:200px;">
                    <a class="aSearch " href="{{searchKey.route}}"
                        *ngFor="let searchKey of searchKeys |  SearchKeySearchPipe : frmSearch.get('searchText').value">
                        <span [ngSwitch]="searchKey.title">
                            <i *ngSwitchCase="'Add Driver'" class="fa fa-user-plus text-danger" aria-hidden="true"></i>
                            <i *ngSwitchCase="'Add Customer'" class="fa fa-user-plus text-danger" aria-hidden="true"></i>
                            <i *ngSwitchCase="'Add Fleet'" class="fa fa-truck text-black" aria-hidden="true"></i>
                            <i *ngSwitchCase="'Job Notifications'" class="fa fa-calendar text-warning" aria-hidden="true"></i>
                            <i *ngSwitchCase="'Map'" class="fa fa-globe text-primary" aria-hidden="true"></i>
                            <i *ngSwitchCase="'Dashboard'" class="fa fa-tachometer text-info" aria-hidden="true"></i>
                            <i *ngSwitchCase="'Driver Montano'" class="fa fa-user text-success" aria-hidden="true"></i>
                            <i *ngSwitchCase="'AJAY PAL SINGH BAJWA'" class="fa fa-user text-success" aria-hidden="true"></i>
                            <i *ngSwitchCase="'Members'" class="fa fa-users text-primary" aria-hidden="true"></i>
                            <i *ngSwitchCase="'Expiries'" class="fa fa-times-circle text-danger" aria-hidden="true"></i>
                            <i *ngSwitchCase="'Driver'" class="fa fa-male text-white" aria-hidden="true"></i>
                            <i *ngSwitchCase="'Customers'" class="fa fa-street-view text-info" aria-hidden="true"></i>      
                        </span>
                        <span class="status text-white">{{searchKey.title}}</span></a>
                </div>
            </div>
        </div>
    </div>
</div>